import promociones from "../api/promociones"
import normalizeDatos from "../normalizers/normalizePromociones";

//PROMOCIONES
export const REQUEST_PROMOCIONES = 'REQUEST_PROMOCIONES';
export const RECEIVE_PROMOCIONES = 'RECEIVE_PROMOCIONES';
export const INVALIDATE_PROMOCIONES = 'INVALIDATE_PROMOCIONES';
export const ERROR_PROMOCIONES= "ERROR_PROMOCIONES";


export function invalidatePromociones(promocion) {
    return {
        type: INVALIDATE_PROMOCIONES,
        promocion
    }
}

function requestPromociones() {
    return {
        type: REQUEST_PROMOCIONES,
    }
}

function receivePromociones(json) {
    return {
        type: RECEIVE_PROMOCIONES,
        promociones: normalizeDatos(json),
        receivedAt: Date.now()
    }
}

function errorPromociones(error) {
    return {
        type: ERROR_PROMOCIONES,
        error: error,
    }
}

function fetchPromociones() {
    return dispatch => {
        dispatch(requestPromociones());
        return promociones.getAll()
            .then(function (response) {
                if (response.status >= 400) {
                    return Promise.reject(response);
                }
                else {
                    var data = response.json();
                    return data;
                }
            })
            .then(function (data) {
                dispatch(receivePromociones(data));
            })
            .catch(function (error) {
                console.log(error);
                switch (error.status) {
                    default:
                        dispatch(errorPromociones("Error General"));
                        return;
                }
            });
    }
}

function shouldFetchPromociones(state) {
    const promociones = state.promociones.byId;
    if (!promociones) {
        return true
    } else if (promociones.isFetching) {
        return false
    } else {
        return promociones.didInvalidate;
    }
}

export function fetchPromocionesIfNeeded() {
    return (dispatch, getState) => {
        if (shouldFetchPromociones(getState())) {
            return dispatch(fetchPromociones())
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/PromocionesActions.js